__turbopack_context__.v({
  "catalog": "GameReferenceCatalog-module__69u8jq__catalog",
  "copy": "GameReferenceCatalog-module__69u8jq__copy",
  "count": "GameReferenceCatalog-module__69u8jq__count",
  "group": "GameReferenceCatalog-module__69u8jq__group",
  "pagination": "GameReferenceCatalog-module__69u8jq__pagination",
  "preview": "GameReferenceCatalog-module__69u8jq__preview",
  "provenance": "GameReferenceCatalog-module__69u8jq__provenance",
  "referenceLink": "GameReferenceCatalog-module__69u8jq__referenceLink",
  "scroller": "GameReferenceCatalog-module__69u8jq__scroller",
  "search": "GameReferenceCatalog-module__69u8jq__search",
  "status": "GameReferenceCatalog-module__69u8jq__status",
  "swatch": "GameReferenceCatalog-module__69u8jq__swatch",
  "toolbar": "GameReferenceCatalog-module__69u8jq__toolbar",
  "value": "GameReferenceCatalog-module__69u8jq__value",
});
